<edit-component
    #termoEditComponent
    rota="termos-de-uso"
    [resource]="termoDeUsoResource"
    [service]="termosDeUsoService"
    [actionsIncrement]="actions"
    [(entidadeOriginal)]="termo"
    (entidadeOriginalChange)="changeEntidadeOriginal($event)"
></edit-component>
